export function generateLivligProductLink(storeId: string, productId: string) {
  if (!storeId || !productId) return null;

  const store = livligStoreFormatter(storeId);
  return `https://item-sales.livlig.ingka.com/locations/SellingUnit/${store}/Item/${productId}`;
}

export function generateLivligProductsLink(
  storeId: string,
  productIds: string
) {
  if (!storeId || !productIds) return null;

  const store = livligStoreFormatter(storeId);
  return `https://item-sales.livlig.ingka.com/locations/SellingUnit/${store}/Items/${productIds}?disableNavigation=1`; // &groupTabType=Items`; // Items can be insights
}

function livligStoreFormatter(storeId: string) {
  const reducedStoreId = storeId.split("#")[0] || "";
  const zeroFill = 5 - reducedStoreId.length;
  return "STO" + "0".repeat(Math.max(zeroFill, 0)) + reducedStoreId;
}
